import { useState } from 'react';
import api from './api';

export default function FormulaTab({ user, formulas, premixes, onRefresh }) {
  const [showAdd, setShowAdd] = useState(false);
  const canEdit = ['admin', 'procurement'].includes(user.role);
  const products = [...new Set(formulas.map(f => f.product))];

  return (
    <div>
      <div style={s.header}>
        <h2 style={s.title}>配方管理</h2>
        {canEdit && <button style={s.btnPrimary} onClick={() => setShowAdd(true)}>+ 新建配方版本</button>}
      </div>

      {products.map(product => (
        <div key={product} style={s.productBlock}>
          <div style={s.productName}>{product}</div>
          <div style={s.tableWrap}>
            <table style={s.table}>
              <thead>
                <tr>{['版本', '生效日期', '产品价格(元/吨)', '预混料组成'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {formulas
                  .filter(f => f.product === product)
                  .sort((a, b) => b.effective_date.localeCompare(a.effective_date))
                  .map(f => (
                    <tr key={f.id} style={s.tr}>
                      <td style={s.td}><span style={s.badge}>{f.version}</span></td>
                      <td style={s.td}>{f.effective_date}</td>
                      <td style={s.td}><span style={s.price}>¥{Number(f.price).toLocaleString()}</span></td>
                      <td style={s.td}>
                        {f.premixItems?.map(item => {
                          const pm = premixes.find(p => p.id === item.premixId);
                          return (
                            <span key={item.premixId} style={s.pmTag}>
                              {pm?.name}：{item.kgPerTon} kg/吨
                            </span>
                          );
                        })}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      {products.length === 0 && <div style={s.empty}>暂无配方，请新建</div>}

      {showAdd && (
        <AddFormulaModal premixes={premixes} formulas={formulas}
          onClose={() => setShowAdd(false)}
          onSave={async data => { await api.post('/formulas', data); setShowAdd(false); onRefresh(); }} />
      )}
    </div>
  );
}

function AddFormulaModal({ premixes, formulas, onClose, onSave }) {
  const products = [...new Set(formulas.map(f => f.product))];
  const [product, setProduct] = useState(products[0] || '');
  const [newProduct, setNewProduct] = useState('');
  const [isNew, setIsNew] = useState(false);
  const [version, setVersion] = useState('');
  const [effectiveDate, setEffectiveDate] = useState(new Date().toISOString().slice(0, 10));
  const [price, setPrice] = useState('');
  const [items, setItems] = useState([{ premixId: premixes[0]?.id, kgPerTon: 0 }]);
  const [saving, setSaving] = useState(false);

  const updateItem = (i, field, val) => setItems(p => p.map((item, idx) => idx === i ? { ...item, [field]: field === 'premixId' ? Number(val) : Number(val) } : item));

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave({
        product: isNew ? newProduct : product,
        version, effective_date: effectiveDate,
        price: Number(price),
        premixItems: items,
      });
    } finally { setSaving(false); }
  };

  return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <div style={s.modalHeader}>
          <span style={s.modalTitle}>新建配方版本</span>
          <button style={s.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={s.formGrid}>
          <label style={s.label}>产品</label>
          <div>
            <select style={s.input} value={isNew ? '__new__' : product}
              onChange={e => { if (e.target.value === '__new__') setIsNew(true); else { setIsNew(false); setProduct(e.target.value); } }}>
              {products.map(p => <option key={p}>{p}</option>)}
              <option value="__new__">+ 新产品</option>
            </select>
            {isNew && <input style={{ ...s.input, marginTop: 8 }} placeholder="输入新产品名称" value={newProduct} onChange={e => setNewProduct(e.target.value)} />}
          </div>
          <label style={s.label}>版本号</label>
          <input style={s.input} placeholder="如 v2" value={version} onChange={e => setVersion(e.target.value)} />
          <label style={s.label}>生效日期</label>
          <input style={s.input} type="date" value={effectiveDate} onChange={e => setEffectiveDate(e.target.value)} />
          <label style={s.label}>价格(元/吨)</label>
          <input style={s.input} type="number" value={price} onChange={e => setPrice(e.target.value)} />
        </div>
        <div style={{ padding: '0 24px 16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <span style={s.label}>预混料组成</span>
            <button style={s.btnSmall} onClick={() => setItems(p => [...p, { premixId: premixes[0]?.id, kgPerTon: 0 }])}>+ 添加</button>
          </div>
          {items.map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
              <select style={{ ...s.inputSm, flex: 2 }} value={item.premixId} onChange={e => updateItem(i, 'premixId', e.target.value)}>
                {premixes.map(pm => <option key={pm.id} value={pm.id}>{pm.name}</option>)}
              </select>
              <input style={{ ...s.inputSm, flex: 1 }} type="number" placeholder="kg/吨" value={item.kgPerTon} onChange={e => updateItem(i, 'kgPerTon', e.target.value)} />
              <span style={{ color: '#475569', fontSize: 12, whiteSpace: 'nowrap' }}>kg/吨</span>
              <button style={{ ...s.btnSmall, color: '#ef4444' }} onClick={() => setItems(p => p.filter((_, idx) => idx !== i))}>✕</button>
            </div>
          ))}
        </div>
        <div style={s.modalFooter}>
          <button style={s.btnSec} onClick={onClose}>取消</button>
          <button style={s.btnPrimary} onClick={handleSave} disabled={saving}>{saving ? '保存中...' : '保存'}</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 10 },
  title: { fontSize: 18, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  productBlock: { marginBottom: 28 },
  productName: { fontSize: 15, fontWeight: 700, color: '#93c5fd', marginBottom: 10, paddingLeft: 2 },
  tableWrap: { overflowX: 'auto', borderRadius: 10, border: '1px solid #1e2d4a' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#0d1529', color: '#64748b', padding: '10px 14px', textAlign: 'left', fontWeight: 600, fontSize: 12, letterSpacing: '0.06em', borderBottom: '1px solid #1e2d4a' },
  tr: { borderBottom: '1px solid #1a2540' },
  td: { padding: '12px 14px', color: '#cbd5e1', verticalAlign: 'top' },
  badge: { display: 'inline-block', background: '#1e3a5f', color: '#38bdf8', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600 },
  price: { color: '#34d399', fontWeight: 700 },
  pmTag: { display: 'inline-block', background: '#1e2d4a', color: '#7dd3fc', padding: '2px 8px', borderRadius: 4, fontSize: 11, marginRight: 4, marginBottom: 2 },
  empty: { color: '#334155', padding: 40, textAlign: 'center' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: 7, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
  btnSec: { background: '#1e2d4a', color: '#94a3b8', border: '1px solid #2d3f5f', padding: '8px 18px', borderRadius: 7, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' },
  btnSmall: { background: '#1a2540', color: '#94a3b8', border: '1px solid #2d3f5f', padding: '4px 10px', borderRadius: 5, cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modal: { background: '#0d1529', border: '1px solid #1e2d4a', borderRadius: 14, width: 'min(560px,95vw)', maxHeight: '85vh', overflowY: 'auto' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 24px', borderBottom: '1px solid #1e2d4a' },
  modalTitle: { fontSize: 15, fontWeight: 700, color: '#f1f5f9' },
  closeBtn: { background: 'none', border: 'none', color: '#64748b', fontSize: 18, cursor: 'pointer' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '16px 24px', borderTop: '1px solid #1e2d4a' },
  formGrid: { display: 'grid', gridTemplateColumns: '90px 1fr', gap: '10px 16px', padding: '20px 24px', alignItems: 'center' },
  label: { fontSize: 12, color: '#64748b', fontWeight: 600, textAlign: 'right' },
  input: { background: '#0a1628', border: '1px solid #2d3f5f', color: '#e2e8f0', padding: '8px 12px', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', width: '100%', boxSizing: 'border-box' },
  inputSm: { background: '#0a1628', border: '1px solid #2d3f5f', color: '#e2e8f0', padding: '6px 10px', borderRadius: 6, fontSize: 12, fontFamily: 'inherit', boxSizing: 'border-box' },
};
